import tinycolor from 'tinycolor2';

export default function hexToRGBA (hex) {
    return tinycolor(hex).toRgbString();
}
